import { c as _c } from "react/compiler-runtime";
import React, { ChangeEvent, useEffect, useState } from 'react';
import { Autocomplete, Button, Checkbox, FormControl, InputLabel, OutlinedInput, Stack, TextField, Typography, useTheme } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { SelectOption, SelectOptions } from './types';
type Props = {
  requestAccessUrl: string;
  options: SelectOptions;
};
export default function RequestAccess(t0) {
  const $ = _c(116);
  const {
    requestAccessUrl,
    options
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      email: "",
      firstname: "",
      lastname: "",
      company: "",
      role: "",
      rigs: t1 as string[],
      applications: t2 as string[],
      comment: ""
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [data, setData] = useState(t3);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isValidRequest, setIsValidRequest] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [inputValueRigs, setInputValueRigs] = useState("");
  const [inputValueApplicatoins, setInputValueApplicatoins] = useState("");
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CheckBoxOutlineBlankIcon fontSize="small" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const icon = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CheckBoxIcon fontSize="small" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const checkedIcon = t5;
  let t6;
  if ($[5] !== data) {
    t6 = e => {
      console.log("Changehandler called");
      setData({
        ...data,
        [e.target.id]: e.target.value
      });
    };
    $[5] = data;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const onChangeDataHandler = t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = (e_0, value) => {
      console.log("Rigs handler called");
      const values = value.map(_temp);
      setData(prevState => ({
        ...prevState,
        rigs: values
      }));
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const onChangeRigsHandler = t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = (e_1, value_0) => {
      const values_0 = value_0.map(_temp2);
      setData(prevState_0 => ({
        ...prevState_0,
        applications: values_0
      }));
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const onChangeApplicationsHandler = t8;
  let t9;
  if ($[9] !== data || $[10] !== requestAccessUrl) {
    t9 = async e_2 => {
      setError("");
      e_2.preventDefault();
      const res = await fetch(requestAccessUrl, {
        body: JSON.stringify(data),
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });
      if (res.ok === false) {
        setSuccess("");
        setError(`Failed to request access: ${res.status} ${res.statusText}`);
      } else {
        setError("");
        setSuccess("Request sent. You will receive an email when your account is ready.");
      }
    };
    $[9] = data;
    $[10] = requestAccessUrl;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const submitHandler = t9;
  let t10;
  if ($[12] !== data.applications || $[13] !== data.comment || $[14] !== data.company || $[15] !== data.email || $[16] !== data.firstname || $[17] !== data.lastname || $[18] !== data.rigs || $[19] !== data.role || $[20] !== isValidRequest) {
    t10 = () => {
      if (data.firstname && data.lastname && data.email && data.company && data.role && data.rigs.length > 0 && data.applications.length > 0 && data.comment) {
        setIsValidRequest(true);
        return;
      }
      if (isValidRequest === true) {
        setIsValidRequest(false);
      }
    };
    $[12] = data.applications;
    $[13] = data.comment;
    $[14] = data.company;
    $[15] = data.email;
    $[16] = data.firstname;
    $[17] = data.lastname;
    $[18] = data.rigs;
    $[19] = data.role;
    $[20] = isValidRequest;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== data) {
    t11 = [data];
    $[22] = data;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  useEffect(t10, t11);
  let t12;
  let t13;
  if ($[24] !== data.email) {
    t12 = () => {
      if (data.email) {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        setIsValidEmail(emailRegex.test(data.email));
      }
    };
    t13 = [data.email];
    $[24] = data.email;
    $[25] = t12;
    $[26] = t13;
  } else {
    t12 = $[25];
    t13 = $[26];
  }
  useEffect(t12, t13);
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = (e_3, value_1, reason, type) => {
      if (e_3 && e_3.type === "blur") {
        type === "rigs" ? setInputValueRigs("") : setInputValueApplicatoins("");
        return;
      } else {
        if (reason !== "reset") {
          type === "rigs" ? setInputValueRigs(value_1) : setInputValueApplicatoins(value_1);
        }
      }
    };
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  const onAutoCompleteInputHandler = t14;
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Typography variant="h5" sx={{
      fontWeight: "bold",
      textAlign: "center"
    }}>Request Access</Typography>;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      xs: "column",
      sm: "row"
    };
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      mb: 2
    };
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  let t19;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      width: "100%",
      mb: 2
    };
    t19 = <InputLabel htmlFor="firstname" required={true}>First name</InputLabel>;
    $[31] = t18;
    $[32] = t19;
  } else {
    t18 = $[31];
    t19 = $[32];
  }
  let t20;
  if ($[33] !== onChangeDataHandler) {
    t20 = e_4 => onChangeDataHandler(e_4);
    $[33] = onChangeDataHandler;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== data.firstname || $[36] !== t20) {
    t21 = <FormControl variant="outlined" size="small" sx={t18}>{t19}<OutlinedInput id="firstname" label="First name" type="text" value={data.firstname} onChange={t20} autoComplete="firstname" /></FormControl>;
    $[35] = data.firstname;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  let t23;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      width: "100%",
      mb: 2
    };
    t23 = <InputLabel htmlFor="lastname" required={true}>Last name</InputLabel>;
    $[38] = t22;
    $[39] = t23;
  } else {
    t22 = $[38];
    t23 = $[39];
  }
  let t24;
  if ($[40] !== onChangeDataHandler) {
    t24 = e_5 => onChangeDataHandler(e_5);
    $[40] = onChangeDataHandler;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== data.lastname || $[43] !== t24) {
    t25 = <FormControl variant="outlined" size="small" sx={t22}>{t23}<OutlinedInput id="lastname" label="Last name" type="text" value={data.lastname} onChange={t24} autoComplete="lastname" /></FormControl>;
    $[42] = data.lastname;
    $[43] = t24;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t21 || $[46] !== t25) {
    t26 = <Stack direction={t16} spacing={2} sx={t17}>{t21}{t25}</Stack>;
    $[45] = t21;
    $[46] = t25;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  let t27;
  let t28;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      width: "100%",
      mb: 2
    };
    t28 = <InputLabel htmlFor="email" required={true}>Email</InputLabel>;
    $[48] = t27;
    $[49] = t28;
  } else {
    t27 = $[48];
    t28 = $[49];
  }
  let t29;
  if ($[50] !== onChangeDataHandler) {
    t29 = e_6 => onChangeDataHandler(e_6);
    $[50] = onChangeDataHandler;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  const t30 = !isValidEmail && data.email.length > 0;
  let t31;
  if ($[52] !== data.email || $[53] !== t29 || $[54] !== t30) {
    t31 = <FormControl variant="outlined" size="small" sx={t27}>{t28}<OutlinedInput id="email" label="Email" type="email" value={data.email} onChange={t29} autoComplete="email" error={t30} /></FormControl>;
    $[52] = data.email;
    $[53] = t29;
    $[54] = t30;
    $[55] = t31;
  } else {
    t31 = $[55];
  }
  let t32;
  let t33;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      width: "100%",
      mb: 2
    };
    t33 = <InputLabel htmlFor="company" required={true}>Company</InputLabel>;
    $[56] = t32;
    $[57] = t33;
  } else {
    t32 = $[56];
    t33 = $[57];
  }
  let t34;
  if ($[58] !== onChangeDataHandler) {
    t34 = e_7 => onChangeDataHandler(e_7);
    $[58] = onChangeDataHandler;
    $[59] = t34;
  } else {
    t34 = $[59];
  }
  let t35;
  if ($[60] !== data.company || $[61] !== t34) {
    t35 = <FormControl variant="outlined" size="small" sx={t32}>{t33}<OutlinedInput id="company" label="Company" type="text" value={data.company} onChange={t34} autoComplete="company" /></FormControl>;
    $[60] = data.company;
    $[61] = t34;
    $[62] = t35;
  } else {
    t35 = $[62];
  }
  let t36;
  let t37;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = {
      width: "100%",
      mb: 2
    };
    t37 = <InputLabel htmlFor="role" required={true}>Role</InputLabel>;
    $[63] = t36;
    $[64] = t37;
  } else {
    t36 = $[63];
    t37 = $[64];
  }
  let t38;
  if ($[65] !== onChangeDataHandler) {
    t38 = e_8 => onChangeDataHandler(e_8);
    $[65] = onChangeDataHandler;
    $[66] = t38;
  } else {
    t38 = $[66];
  }
  let t39;
  if ($[67] !== data.role || $[68] !== t38) {
    t39 = <FormControl variant="outlined" size="small" sx={t36}>{t37}<OutlinedInput id="role" label="Role" type="text" value={data.role} onChange={t38} /></FormControl>;
    $[67] = data.role;
    $[68] = t38;
    $[69] = t39;
  } else {
    t39 = $[69];
  }
  let t40;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = {
      width: "100%",
      mb: 2
    };
    $[70] = t40;
  } else {
    t40 = $[70];
  }
  let t41;
  let t42;
  let t43;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = (props, option, t44) => {
      const {
        selected
      } = t44;
      return <li {...props}><Checkbox icon={icon} checkedIcon={checkedIcon} style={{
          marginRight: 8
        }} checked={selected} />{option.label}</li>;
    };
    t42 = (e_9, value_2) => onChangeRigsHandler(e_9, value_2);
    t43 = (e_10, value_3, reason_0) => onAutoCompleteInputHandler(e_10, value_3, reason_0, "rigs");
    $[71] = t41;
    $[72] = t42;
    $[73] = t43;
  } else {
    t41 = $[71];
    t42 = $[72];
    t43 = $[73];
  }
  let t44;
  if ($[74] !== inputValueRigs || $[75] !== options.rigs) {
    t44 = <FormControl variant="outlined" size="small" sx={t40}><Autocomplete id="rigs" multiple={true} options={options.rigs} renderInput={_temp3} size="small" disableCloseOnSelect={true} renderOption={t41} onChange={t42} onInputChange={t43} inputValue={inputValueRigs} /></FormControl>;
    $[74] = inputValueRigs;
    $[75] = options.rigs;
    $[76] = t44;
  } else {
    t44 = $[76];
  }
  let t45;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = {
      width: "100%",
      mb: 2
    };
    $[77] = t45;
  } else {
    t45 = $[77];
  }
  let t46;
  let t47;
  let t48;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = (props_0, option_0, t49) => {
      const {
        selected: selected_0
      } = t49;
      return <li {...props_0}><Checkbox icon={icon} checkedIcon={checkedIcon} style={{
          marginRight: 8
        }} checked={selected_0} />{option_0.label}</li>;
    };
    t47 = (e_11, value_4) => onChangeApplicationsHandler(e_11, value_4);
    t48 = (e_12, value_5, reason_1) => onAutoCompleteInputHandler(e_12, value_5, reason_1, "applications");
    $[78] = t46;
    $[79] = t47;
    $[80] = t48;
  } else {
    t46 = $[78];
    t47 = $[79];
    t48 = $[80];
  }
  let t49;
  if ($[81] !== inputValueApplicatoins || $[82] !== options.applications) {
    t49 = <FormControl variant="outlined" size="small" sx={t45}><Autocomplete id="applications" multiple={true} options={options.applications} renderInput={_temp4} size="small" disableCloseOnSelect={true} renderOption={t46} onChange={t47} onInputChange={t48} inputValue={inputValueApplicatoins} /></FormControl>;
    $[81] = inputValueApplicatoins;
    $[82] = options.applications;
    $[83] = t49;
  } else {
    t49 = $[83];
  }
  let t50;
  let t51;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = {
      width: "100%",
      mb: 2
    };
    t51 = <InputLabel htmlFor="comment" required={true}>Comment</InputLabel>;
    $[84] = t50;
    $[85] = t51;
  } else {
    t50 = $[84];
    t51 = $[85];
  }
  let t52;
  if ($[86] !== onChangeDataHandler) {
    t52 = e_13 => onChangeDataHandler(e_13);
    $[86] = onChangeDataHandler;
    $[87] = t52;
  } else {
    t52 = $[87];
  }
  let t53;
  if ($[88] !== data.comment || $[89] !== t52) {
    t53 = <OutlinedInput id="comment" label="Comment" type="text" multiline={true} rows={5} value={data.comment} onChange={t52} />;
    $[88] = data.comment;
    $[89] = t52;
    $[90] = t53;
  } else {
    t53 = $[90];
  }
  let t54;
  if ($[91] !== theme.palette.text.secondary) {
    t54 = <Typography variant="caption" sx={{
      mt: 1,
      color: theme.palette.text.secondary
    }}>Explain you current work role and why you require access</Typography>;
    $[91] = theme.palette.text.secondary;
    $[92] = t54;
  } else {
    t54 = $[92];
  }
  let t55;
  if ($[93] !== t53 || $[94] !== t54) {
    t55 = <FormControl variant="outlined" size="small" sx={t50}>{t51}{t53}{t54}</FormControl>;
    $[93] = t53;
    $[94] = t54;
    $[95] = t55;
  } else {
    t55 = $[95];
  }
  let t56;
  if ($[96] !== error || $[97] !== theme.palette.error) {
    t56 = error ? <Typography sx={{
      textAlign: "center",
      fontSize: 14,
      mb: 2,
      color: theme.palette.error.main
    }}>{error}</Typography> : null;
    $[96] = error;
    $[97] = theme.palette.error;
    $[98] = t56;
  } else {
    t56 = $[98];
  }
  let t57;
  if ($[99] !== success || $[100] !== theme.palette.success) {
    t57 = success ? <Typography sx={{
      color: theme.palette.success.main,
      textAlign: "center",
      fontSize: 14,
      mb: 2
    }}>{success}</Typography> : null;
    $[99] = success;
    $[100] = theme.palette.success;
    $[101] = t57;
  } else {
    t57 = $[101];
  }
  const t58 = !isValidRequest || !isValidEmail;
  let t59;
  if ($[102] !== t58) {
    t59 = <Button variant="contained" size="large" type="submit" fullWidth={true} disabled={t58}>Request Access</Button>;
    $[102] = t58;
    $[103] = t59;
  } else {
    t59 = $[103];
  }
  let t60;
  if ($[104] !== submitHandler || $[105] !== t26 || $[106] !== t31 || $[107] !== t35 || $[108] !== t39 || $[109] !== t44 || $[110] !== t49 || $[111] !== t55 || $[112] !== t56 || $[113] !== t57 || $[114] !== t59) {
    t60 = <Stack spacing={4}>{t15}<form onSubmit={submitHandler}>{t26}{t31}{t35}{t39}{t44}{t49}{t55}{t56}{t57}{t59}</form></Stack>;
    $[104] = submitHandler;
    $[105] = t26;
    $[106] = t31;
    $[107] = t35;
    $[108] = t39;
    $[109] = t44;
    $[110] = t49;
    $[111] = t55;
    $[112] = t56;
    $[113] = t57;
    $[114] = t59;
    $[115] = t60;
  } else {
    t60 = $[115];
  }
  return t60;
}
function _temp4(params_0) {
  return <TextField {...params_0} label="Applications *" placeholder="Search applications" />;
}
function _temp3(params) {
  return <TextField {...params} label="Rigs *" placeholder="Search rigs" />;
}
function _temp2(v_0) {
  return v_0.value;
}
function _temp(v) {
  return v.value;
}